"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerDesignReviewRequestSchema = exports.designReviewResultSchema = exports.triggerDesignReviewFailureSchema = exports.triggerDesignReviewSuccessSchema = exports.priorityMap = exports.ReviewCategory = exports.Review = exports.ReviewCheck = exports.ReviewColumn = exports.ReviewAvailability = exports.ReviewColumnAlign = exports.ReviewCheckAssignedStatus = exports.ReviewAssignedStatus = exports.ReviewStatus = exports.ReviewCategoryType = exports.reviewUidToReviewTypeMap = exports.ReviewType = exports.emptyReviewDataPlaceholder = void 0;
exports.isDesignRuleCheckType = isDesignRuleCheckType;
exports.isElectricalRuleCheckType = isElectricalRuleCheckType;
exports.isAutoLayoutCheckType = isAutoLayoutCheckType;
exports.createDRCCheckId = createDRCCheckId;
exports.aggregateReviewStatus = aggregateReviewStatus;
exports.aggregateReviewCheckStatus = aggregateReviewCheckStatus;
const zod_1 = require("zod");
const identifier_1 = require("../identifier");
const validation_1 = require("../validation");
exports.emptyReviewDataPlaceholder = "None";
var ReviewType;
(function (ReviewType) {
    ReviewType["DecouplingCaps"] = "decoupling_caps";
    ReviewType["ResistorPowerRating"] = "resistor_power_rating";
    ReviewType["PullUpPullDown"] = "pull_up_pull_down";
    ReviewType["CapacitorVoltageRating"] = "capacitor_voltage_rating";
    ReviewType["PartsAvailable"] = "parts_available";
    ReviewType["DesignRuleCheckAirwire"] = "design_rule_check_airwires";
    ReviewType["DesignRuleCheckFloatingCopper"] = "design_rule_check_floating_copper";
    ReviewType["DesignRuleCheckOverlappingCopper"] = "design_rule_check_overlapping_copper";
    ReviewType["DesignRuleCheckComponentOverrides"] = "design_rule_check_important_override";
    ReviewType["DesignRuleCheckMissingFootprints"] = "design_rule_check_missing_footprints";
    ReviewType["DesignRuleCheckManufacturePartNumber"] = "design_rule_check_manufacture_part_number";
    ReviewType["DesignRuleCheckInvalidLayer"] = "design_rule_check_invalid_layer";
    ReviewType["DesignRuleCheckOverlappingFills"] = "design_rule_check_overlapping_fills";
    ReviewType["DesignRuleCheckDeprecatedRules"] = "design_rule_check_deprecated_rules";
    ReviewType["DesignRuleCheckTraceCornerRadius"] = "design_rule_check_trace_corner_radius";
    ReviewType["DesignRuleCheckProtectedIntrusions"] = "design_rule_check_protected_intrusions";
    /** @deprecated Use DesignRuleCheckOverlappingCopper instead */
    ReviewType["DesignRuleCheckOverlappingTraces"] = "design_rule_check_overlapping_traces";
    // ERC (Electrical Rule Check) validators
    ReviewType["DesignRuleCheckErcDriverConflict"] = "design_rule_check_erc_driver_conflict";
    ReviewType["DesignRuleCheckErcDuplicateReference"] = "design_rule_check_erc_duplicate_reference";
    ReviewType["DesignRuleCheckErcFloatingPin"] = "design_rule_check_erc_floating_pin";
    ReviewType["DesignRuleCheckErcNoConnect"] = "design_rule_check_erc_no_connect";
    ReviewType["DesignRuleCheckErcPinToPin"] = "design_rule_check_erc_pin_to_pin";
    ReviewType["DesignRuleCheckErcShortedComponents"] = "design_rule_check_erc_shorted_components";
    ReviewType["DesignRuleCheckErcPowerPin"] = "design_rule_check_erc_power_pin";
    ReviewType["DesignRuleCheckErcSimilarLabels"] = "design_rule_check_erc_similar_labels";
    ReviewType["DesignRuleCheckErcSinglePinNet"] = "design_rule_check_erc_single_pin_net";
    ReviewType["DesignRuleCheckErcUndrivenNet"] = "design_rule_check_erc_undriven_net";
    // Additional ERC validators
    ReviewType["DesignRuleCheckErcWireDangling"] = "design_rule_check_erc_wire_dangling";
    ReviewType["DesignRuleCheckErcUnconnectedWireEndpoint"] = "design_rule_check_erc_unconnected_wire_endpoint";
    ReviewType["DesignRuleCheckErcUnannotated"] = "design_rule_check_erc_unannotated";
    ReviewType["DesignRuleCheckErcSimilarPower"] = "design_rule_check_erc_similar_power";
    ReviewType["DesignRuleCheckErcSimilarLabelAndPower"] = "design_rule_check_erc_similar_label_and_power";
    ReviewType["DesignRuleCheckErcDifferentUnitFootprint"] = "design_rule_check_erc_different_unit_footprint";
    ReviewType["DesignRuleCheckErcDifferentUnitNet"] = "design_rule_check_erc_different_unit_net";
    ReviewType["DesignRuleCheckErcDifferentUnitValue"] = "design_rule_check_erc_different_unit_value";
    ReviewType["SystemChecksAutoLayout"] = "system_checks_auto_layout";
})(ReviewType || (exports.ReviewType = ReviewType = {}));
exports.reviewUidToReviewTypeMap = {
    rev_decoupling_caps: ReviewType.DecouplingCaps,
    rev_resistor_power_rating: ReviewType.ResistorPowerRating,
    rev_pull_up_pull_down: ReviewType.PullUpPullDown,
    rev_capacitor_voltage_rating: ReviewType.CapacitorVoltageRating,
    rev_parts_available: ReviewType.PartsAvailable,
    rev_design_rule_check_airwires: ReviewType.DesignRuleCheckAirwire,
    rev_design_rule_check_floating_copper: ReviewType.DesignRuleCheckFloatingCopper,
    rev_design_rule_check_overlapping_copper: ReviewType.DesignRuleCheckOverlappingCopper,
    rev_design_rule_check_important_override: ReviewType.DesignRuleCheckComponentOverrides,
    rev_design_rule_check_missing_footprints: ReviewType.DesignRuleCheckMissingFootprints,
    rev_design_rule_check_manufacture_part_number: ReviewType.DesignRuleCheckManufacturePartNumber,
    rev_design_rule_check_invalid_layer: ReviewType.DesignRuleCheckInvalidLayer,
    rev_design_rule_check_overlapping_fills: ReviewType.DesignRuleCheckOverlappingFills,
    rev_design_rule_check_deprecated_rules: ReviewType.DesignRuleCheckDeprecatedRules,
    rev_design_rule_check_trace_corner_radius: ReviewType.DesignRuleCheckTraceCornerRadius,
    rev_design_rule_check_protected_intrusions: ReviewType.DesignRuleCheckProtectedIntrusions,
    /** @deprecated */
    rev_design_rule_check_overlapping_traces: ReviewType.DesignRuleCheckOverlappingTraces,
    // ERC validators
    rev_design_rule_check_erc_driver_conflict: ReviewType.DesignRuleCheckErcDriverConflict,
    rev_design_rule_check_erc_duplicate_reference: ReviewType.DesignRuleCheckErcDuplicateReference,
    rev_design_rule_check_erc_floating_pin: ReviewType.DesignRuleCheckErcFloatingPin,
    rev_design_rule_check_erc_no_connect: ReviewType.DesignRuleCheckErcNoConnect,
    rev_design_rule_check_erc_pin_to_pin: ReviewType.DesignRuleCheckErcPinToPin,
    rev_design_rule_check_erc_shorted_components: ReviewType.DesignRuleCheckErcShortedComponents,
    rev_design_rule_check_erc_power_pin: ReviewType.DesignRuleCheckErcPowerPin,
    rev_design_rule_check_erc_similar_labels: ReviewType.DesignRuleCheckErcSimilarLabels,
    rev_design_rule_check_erc_single_pin_net: ReviewType.DesignRuleCheckErcSinglePinNet,
    rev_design_rule_check_erc_undriven_net: ReviewType.DesignRuleCheckErcUndrivenNet,
    // Additional ERC validators
    rev_design_rule_check_erc_wire_dangling: ReviewType.DesignRuleCheckErcWireDangling,
    rev_design_rule_check_erc_unconnected_wire_endpoint: ReviewType.DesignRuleCheckErcUnconnectedWireEndpoint,
    rev_design_rule_check_erc_unannotated: ReviewType.DesignRuleCheckErcUnannotated,
    rev_design_rule_check_erc_similar_power: ReviewType.DesignRuleCheckErcSimilarPower,
    rev_design_rule_check_erc_similar_label_and_power: ReviewType.DesignRuleCheckErcSimilarLabelAndPower,
    rev_design_rule_check_erc_different_unit_footprint: ReviewType.DesignRuleCheckErcDifferentUnitFootprint,
    rev_design_rule_check_erc_different_unit_net: ReviewType.DesignRuleCheckErcDifferentUnitNet,
    rev_design_rule_check_erc_different_unit_value: ReviewType.DesignRuleCheckErcDifferentUnitValue,
    rev_system_checks_auto_layout: ReviewType.SystemChecksAutoLayout,
};
var ReviewCategoryType;
(function (ReviewCategoryType) {
    ReviewCategoryType["DesignRuleChecks"] = "Design Rule Checks";
    ReviewCategoryType["ElectricalRuleChecks"] = "Electrical Rule Checks";
    ReviewCategoryType["Manufacturing"] = "Manufacturing";
    ReviewCategoryType["PassiveComponents"] = "Passive Components";
    ReviewCategoryType["SystemChecks"] = "System Checks";
})(ReviewCategoryType || (exports.ReviewCategoryType = ReviewCategoryType = {}));
function isDesignRuleCheckType(type) {
    switch (type) {
        case ReviewType.DesignRuleCheckAirwire:
        case ReviewType.DesignRuleCheckFloatingCopper:
        case ReviewType.DesignRuleCheckOverlappingCopper:
        case ReviewType.DesignRuleCheckOverlappingTraces:
        case ReviewType.DesignRuleCheckComponentOverrides:
        case ReviewType.DesignRuleCheckMissingFootprints:
        case ReviewType.DesignRuleCheckManufacturePartNumber:
        case ReviewType.DesignRuleCheckInvalidLayer:
        case ReviewType.DesignRuleCheckOverlappingFills:
        case ReviewType.DesignRuleCheckDeprecatedRules:
        case ReviewType.DesignRuleCheckTraceCornerRadius:
        case ReviewType.DesignRuleCheckProtectedIntrusions:
            return true;
        default:
            return false;
    }
}
function isElectricalRuleCheckType(type) {
    switch (type) {
        case ReviewType.DesignRuleCheckErcDriverConflict:
        case ReviewType.DesignRuleCheckErcDuplicateReference:
        case ReviewType.DesignRuleCheckErcFloatingPin:
        case ReviewType.DesignRuleCheckErcNoConnect:
        case ReviewType.DesignRuleCheckErcPinToPin:
        case ReviewType.DesignRuleCheckErcShortedComponents:
        case ReviewType.DesignRuleCheckErcPowerPin:
        case ReviewType.DesignRuleCheckErcSimilarLabels:
        case ReviewType.DesignRuleCheckErcSinglePinNet:
        case ReviewType.DesignRuleCheckErcUndrivenNet:
        // eslint-disable-next-line no-fallthrough
        case ReviewType.DesignRuleCheckErcWireDangling:
        case ReviewType.DesignRuleCheckErcUnconnectedWireEndpoint:
        case ReviewType.DesignRuleCheckErcUnannotated:
        case ReviewType.DesignRuleCheckErcSimilarPower:
        case ReviewType.DesignRuleCheckErcSimilarLabelAndPower:
        case ReviewType.DesignRuleCheckErcDifferentUnitFootprint:
        case ReviewType.DesignRuleCheckErcDifferentUnitNet:
        case ReviewType.DesignRuleCheckErcDifferentUnitValue:
            return true;
        default:
            return false;
    }
}
function isAutoLayoutCheckType(type) {
    return type === ReviewType.SystemChecksAutoLayout;
}
function createDRCCheckId(type, affectedItemUids) {
    const ids = Array.from(new Set(affectedItemUids.filter(Boolean)))
        .sort()
        .join(":");
    return `rch_${type}_${ids}`;
}
var ReviewStatus;
(function (ReviewStatus) {
    ReviewStatus["OPEN"] = "OPEN";
    ReviewStatus["USER"] = "USER";
    ReviewStatus["UNRUN"] = "UNRUN";
    ReviewStatus["SUCCESS_AND_STALE"] = "SUCCESS_AND_STALE";
    ReviewStatus["SUCCESS_AND_UNRUN"] = "SUCCESS_AND_UNRUN";
    ReviewStatus["SUCCESS"] = "SUCCESS";
    ReviewStatus["UNCERTAIN"] = "UNCERTAIN";
    ReviewStatus["WARNING"] = "WARNING";
    ReviewStatus["ERROR"] = "ERROR";
    ReviewStatus["RUNNING"] = "RUNNING";
    ReviewStatus["INFORMATIONAL"] = "INFORMATIONAL";
})(ReviewStatus || (exports.ReviewStatus = ReviewStatus = {}));
var ReviewAssignedStatus;
(function (ReviewAssignedStatus) {
    ReviewAssignedStatus["RESOLVED"] = "RESOLVED";
    ReviewAssignedStatus["MUTED"] = "MUTED";
})(ReviewAssignedStatus || (exports.ReviewAssignedStatus = ReviewAssignedStatus = {}));
var ReviewCheckAssignedStatus;
(function (ReviewCheckAssignedStatus) {
    ReviewCheckAssignedStatus["MUTED"] = "MUTED";
})(ReviewCheckAssignedStatus || (exports.ReviewCheckAssignedStatus = ReviewCheckAssignedStatus = {}));
var ReviewColumnAlign;
(function (ReviewColumnAlign) {
    ReviewColumnAlign["LEFT"] = "LEFT";
    ReviewColumnAlign["RIGHT"] = "RIGHT";
})(ReviewColumnAlign || (exports.ReviewColumnAlign = ReviewColumnAlign = {}));
var ReviewAvailability;
(function (ReviewAvailability) {
    ReviewAvailability["INTERNAL"] = "Internal";
    ReviewAvailability["BETA"] = "Beta";
    ReviewAvailability["RELEASED"] = "Released";
})(ReviewAvailability || (exports.ReviewAvailability = ReviewAvailability = {}));
exports.ReviewColumn = zod_1.z.object({
    uid: identifier_1.ReviewColumnUid,
    reviewUid: identifier_1.ReviewUid,
    documentUid: identifier_1.DocumentUid,
    name: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    field: zod_1.z.string(),
    index: zod_1.z.number(),
    align: zod_1.z.nativeEnum(ReviewColumnAlign).optional(),
    width: zod_1.z.string().optional(),
    fullViewWidth: zod_1.z.string().optional(),
    isDefault: zod_1.z.boolean().optional(),
    isLink: zod_1.z.boolean().optional(),
});
exports.ReviewCheck = zod_1.z.object({
    uid: identifier_1.ReviewCheckUid,
    reviewUid: identifier_1.ReviewUid,
    documentUid: identifier_1.DocumentUid,
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    index: zod_1.z.number(),
    status: zod_1.z.nativeEnum(ReviewStatus),
    assignedStatus: zod_1.z.nativeEnum(ReviewCheckAssignedStatus).optional(),
    data: zod_1.z.record(zod_1.z.any()),
    link: zod_1.z.string(),
    designator: zod_1.z.string(),
    designatorUidMap: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
    createdAt: validation_1.Timestamp.optional(), // Optional because they don't always exist at runtime currently
    updatedAt: validation_1.Timestamp.optional(),
});
exports.Review = zod_1.z.object({
    uid: identifier_1.ReviewUid,
    documentUid: identifier_1.DocumentUid,
    name: zod_1.z.string(),
    type: zod_1.z.nativeEnum(ReviewType),
    description: zod_1.z.string(),
    documentationUrl: zod_1.z.string().optional(),
    error: zod_1.z.string().optional(),
    category: zod_1.z.string(), // Should this be an enum?
    status: zod_1.z.nativeEnum(ReviewStatus),
    assignedStatus: zod_1.z.nativeEnum(ReviewAssignedStatus).optional(),
    checks: zod_1.z.record(exports.ReviewCheck),
    columns: zod_1.z.record(exports.ReviewColumn),
    availability: zod_1.z.nativeEnum(ReviewAvailability),
    createdAt: validation_1.Timestamp,
    updatedAt: validation_1.Timestamp,
});
exports.ReviewCategory = zod_1.z.object({
    name: zod_1.z.string(),
    status: zod_1.z.nativeEnum(ReviewStatus),
    reviews: zod_1.z.array(exports.Review),
});
exports.priorityMap = {
    [ReviewStatus.OPEN]: 0,
    [ReviewStatus.USER]: 1,
    [ReviewStatus.UNRUN]: 2,
    [ReviewStatus.INFORMATIONAL]: 3,
    [ReviewStatus.SUCCESS_AND_STALE]: 4,
    [ReviewStatus.SUCCESS_AND_UNRUN]: 5,
    [ReviewStatus.SUCCESS]: 6,
    [ReviewStatus.UNCERTAIN]: 7,
    [ReviewStatus.WARNING]: 8,
    [ReviewStatus.ERROR]: 9,
    [ReviewStatus.RUNNING]: 10,
    [ReviewAssignedStatus.RESOLVED]: 11,
    [ReviewAssignedStatus.MUTED]: 12,
};
function isReviewAssignedStatus(status) {
    return [ReviewAssignedStatus.MUTED, ReviewAssignedStatus.RESOLVED].includes(status);
}
function isReviewCheckAssignedStatus(status) {
    return [ReviewCheckAssignedStatus.MUTED].includes(status);
}
function aggregateReviewStatus(statuses) {
    const reviewStatuses = statuses.filter((status) => !isReviewAssignedStatus(status));
    return reviewStatuses.reduce((criticalStatus, status) => {
        return exports.priorityMap[criticalStatus] < exports.priorityMap[status] ? status : criticalStatus;
    }, ReviewStatus.OPEN);
}
function aggregateReviewCheckStatus(statuses) {
    const reviewStatuses = statuses.filter((status) => !isReviewCheckAssignedStatus(status));
    return reviewStatuses.reduce((criticalStatus, status) => {
        return exports.priorityMap[criticalStatus] < exports.priorityMap[status] ? status : criticalStatus;
    }, ReviewStatus.OPEN);
}
exports.triggerDesignReviewSuccessSchema = zod_1.z.object({
    type: zod_1.z.literal("success"),
    data: exports.Review,
});
exports.triggerDesignReviewFailureSchema = zod_1.z.object({
    type: zod_1.z.literal("failure"),
    failureReason: zod_1.z.string(),
});
exports.designReviewResultSchema = zod_1.z.discriminatedUnion("type", [
    exports.triggerDesignReviewSuccessSchema,
    exports.triggerDesignReviewFailureSchema,
]);
exports.triggerDesignReviewRequestSchema = zod_1.z.object({
    check: zod_1.z.nativeEnum(ReviewType),
    documentUid: zod_1.z.string(),
});
//# sourceMappingURL=types.js.map